import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { consumeCallbackParams } from '@motivo/styx/src/urlCallbackParams';

const API_URL = import.meta.env.VITE_API_URL;

function Callback() {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      const { code, state } = consumeCallbackParams() ?? { code: null, state: null };
      const sessionId = JSON.parse(state || '{}').sessionId;

      if (!code) {
        setError('No authorization code received');
        return;
      }

      if (!sessionId) {
        setError('No session ID received');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/session/complete/${sessionId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to complete authentication');
        }

        setSuccess(true);

        setTimeout(() => {
          window.close();
        }, 1000);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={3}
    >
      {error ? (
        <>
          <Typography variant="h6" color="error" gutterBottom>
            Authentication error
          </Typography>
          <Typography color="textSecondary">{error}</Typography>
        </>
      ) : success ? (
        <>
          <Typography variant="h6" color="success.main" gutterBottom>
            Authentication successful
          </Typography>
          <Typography color="textSecondary">
            This window will close automatically, or you can close it now.
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography mt={2}>Completing authentication...</Typography>
        </>
      )}
    </Box>
  );
}

export default Callback;
